export default {
    name: 'auth',
    serverName: '/auth/',
    apiUrl: '/auth/'
};
